import Vue from "vue";
import Router from "vue-router";
import DashboardLayout from "@/layout/DashboardLayout";
import AuthLayout from "@/layout/AuthLayout";
import APP_CONFIG from "./config/config";
import EventDetail from "@/views/EventDetails";
import UserProfile from "@/views/UserProfile/UserProfile";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  mode: "history",
  hash: false,
  routes: [
    {
      path: "/eid/:id",
      name: "e",
      component: EventDetail,
      meta: {
        noAuth: true,
      },
    },
    {
      path: "/eid/:id/confirmation/:status",
      name: "success",
      component: () => import("./views/Success/Success.vue"),
      meta: {
        noAuth: true,
      },
    },
    {
      path: "/ticket/:id/confirmation/canceled",
      name: "error",
      component: () => import("./views/Error/Error.vue"),
      meta: { noAuth: true },
    },
    {
      path: "/eid/:id/confirmation/canceled",
      name: "errorslist",
      component: () => import("./views/Error/Error.vue"),
      meta: {
        noAuth: true,
      },
    },
    {
      path: "/user/:id",
      name: "user",
      component: UserProfile,
      meta: {
        noAuth: true,
      },
    },
    {
      path: "/",
      redirect: "explore",
      component: DashboardLayout,
      children: [
        {
          path: "/post-event",
          name: "post-event",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/PostEvent.vue"),
          props: true,
          meta: { title: `${APP_CONFIG.APP_TITLE} | Post Event` },
        },
        {
          path: "/explore",
          name: "explore",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/Explore.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | Explore` },
        },
        {
          path: "/checkouts",
          name: "checkouts",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/checkout/checkout.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | checkout` },
        },
        {
          path: "/checkouts2",
          name: "checkouts2",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/checkout2/checkout2.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | checkout` },
        },
        {
          path: "/events/:id",
          name: "event",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/EventDetail.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | Event Detail` },
        },
        // {
        //   path: "/account",
        //   name: "account",
        //   component: () =>
        //     import(/* webpackChunkName: "demo" */ "./views/Accounts.vue"),
        //   meta: { title: `${APP_CONFIG.APP_TITLE} | Account` },
        // },
        // {
        //   path: '/profile',
        //   name: 'profile',
        //   component: () => import(/* webpackChunkName: "demo" */ './views/UserProfile.vue'),
        //   meta: { title: `${APP_CONFIG.APP_TITLE} | Profile` },
        // },
        {
          path: "/my-likes",
          name: "my-likes",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/MyLikes.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | My Likes` },
        },
        {
          path: "/activity",
          name: "activity",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/myActivities.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | Messages` },
        },
        {
          path: "/messages",
          name: "messages",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/Messages.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | Messages` },
        },
        {
          path: "/notification",
          name: "notification",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/notification.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | Notification` },
        },
        {
          path: "/add-ticket",
          name: "add ticket",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/AddTickets/AddTickets.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | Tickets` },
        },
        {
          path: "/ticket/:id",
          name: "my ticket",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/myAllTickets/myAllTickets.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | Tickets`, noAuth: true },
        },
        {
          path: "/ticketslist/:id",
          name: "my ticketsdata",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/myAllTickets/myAllTickets.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | Tickets`, noAuth: true },
        },
        {
          path: "/account",
          name: "account",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/ticketList/ticketList.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | Tickets` },
        },
      ],
    },
    {
      path: "/",
      redirect: "login",
      component: AuthLayout,
      children: [
        {
          path: "/login",
          name: "login",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/Login.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | Login`, noAuth: true },
        },
        {
          path: "/logout",
          name: "logout",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/Login.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | Logout`, noAuth: true },
        },
        {
          path: "/register",
          name: "register",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/Register.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | Register`, noAuth: true },
        },
        {
          path: "/phrases",
          name: "phrases",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/Phrases.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | Entertainment` },
        },
        {
          path: "/categories",
          name: "categories",
          component: () =>
            import(/* webpackChunkName: "demo" */ "./views/Categories.vue"),
          meta: { title: `${APP_CONFIG.APP_TITLE} | Categories` },
        },
        {
          path: "/forgot-password",
          name: "forget",
          component: () => import("./views/forgetPassword/forgetPassword.vue"),
          meta: { title: "Forgot Password", noAuth: true },
        },
      ],
    },
    {
      path: "*",
      redirect: "login",
    },
  ],
});
